import { render, staticRenderFns } from "./newstEvent.vue?vue&type=template&id=62fe0378&scoped=true&"
import script from "./newstEvent.vue?vue&type=script&lang=js&"
export * from "./newstEvent.vue?vue&type=script&lang=js&"
import style0 from "./newstEvent.vue?vue&type=style&index=0&id=62fe0378&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62fe0378",
  null
  
)

export default component.exports